import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_ABSENT_DAYS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_ABSENT_DAY:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_ABSENT_DAY:
      // return { ...state, [action.payload.Id]: action.payload };
      return { ..._.mapKeys(action.payload, "Id") };
    case type.EDIT_ABSENT_DAY:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_ABSENT_DAY:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
